var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.globalCouponData && !_vm.invalidCoupon)?_c('b-alert',{staticClass:"mb-4",attrs:{"show":"","variant":"success"}},[_c('strong',[_vm._v(" "+_vm._s(_vm.globalCouponData.title)+" ")]),_c('br'),_vm._v(" "+_vm._s(_vm.globalCouponData.content)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }